import { get } from '../api/api'
// import store from '../store/index'

export const getFormEmptyField = (formObj) => {
  const checkFieldList = []
  const checkList = ['id', 'contactPhone', 'mmFollowStaffList', 'sourceExplain', 'industryExplain', 'post',
    'mmRecordStaffList', 'mmRemindStaffList', 'docEReceiveList',
    'address', 'lng', 'lat', 'cusType', 'certType', 'locationDate', 'remark'
  ]
  Object.keys(formObj).forEach(key => {
    if (checkList.includes(key)) {
      return true
    }
    if (!(formObj[key].length > 0 || String(formObj[key]).length > 0)) {
      checkFieldList.push(key)
    }
  })
  return checkFieldList
}

export const getIndustryDict = async (value) => {
  const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
    opttype: 'STD_MM_CUS_INDUSTRY'
  })
  const data = result.data.filter(item => item.enname === value)[0]
  return data ? data.cnname : '无'
}

export const getSourceDict = async (value) => {
  const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
    opttype: 'STD_MM_CUS_SOURCE'
  })
  const data = result.data.filter(item => item.enname === value)[0]
  return data ? data.cnname : '无'
}

export const getFollowupType = async () => {
  const result = await get('/api/CBMS-APP/sDic/getOpttypeList', {
    opttype: 'STD_MM_FOLLOW_TYPE'
  })
  if (result.success) {
    return result.data
  }
}

export const addthousandchar = (num) => {
  let count = 0
  let numArr1 = []
  let numArr2 = []
  const numArr3 = []
  numArr1 = num.split('.')
  if (numArr1.length === 1) {
    numArr1.push('00')
  }
  numArr2 = numArr1[0].split('')
  count = Math.ceil(numArr2.length / 3)
  for (var i = 0; i < count; i++) {
    if (numArr2.length < 3) {
      numArr3.unshift(',')
      numArr3.unshift(numArr2.splice(0, 3).join(''))
    } else {
      numArr3.unshift(',')
      numArr3.unshift(numArr2.splice(numArr2.length - 3, 3).join(''))
    }
    //
  }
  numArr3.pop()
  numArr3.push('.')
  numArr3.push(numArr1[1])
  return numArr3.join('')
}
